const STORAGE_KEY = 'betuple_cookie_consent';
const VERSION = 1;

export function readCookieConsent() {
    if (typeof localStorage === 'undefined') {
        return null;
    }
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const data = JSON.parse(raw);
        if (!data || data.v !== VERSION || typeof data.analytics !== 'boolean') {
            return null;
        }
        return { v: VERSION, analytics: data.analytics };
    } catch {
        return null;
    }
}

export function writeCookieConsent(consent) {
    if (typeof localStorage === 'undefined') {
        return;
    }
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch {
        // private mode or quota
    }
}
